export const unsupportedBrowserMessageComponent = {
  key: 'unsupportedBrowserMessageComponent',
  name: 'Unsupported Browser Message Component',
  siteIdentifier: 'global',

  unsupportedBrowserMessage: `Important: The browser you are currently using will not work with our
        website. We recommend you {link}.`,
  upgradeYourBrowserLink: 'upgrade your browser',
};
